import { SVGProps } from 'react';

export const ThreeDots = (props: SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <circle cx={12.667} cy={8} fill='#1D242D' r={1.333} />
    <circle cx={8} cy={8} r={1.333} fill='#1D242D' />
    <circle cx={3.333} cy={8} r={1.333} fill='#1D242D' />
  </svg>
);
